import React from 'react';
import { FormatDateOptions, FormattedRelativeTime, useIntl } from 'react-intl';
import selectValueAndUnit from '@99designs/frontend-components/i18n/selectValueAndUnit';
import { DateTime } from 'luxon';

export type DateSource = number | Date | string;

export interface Props {
    date: DateSource;
}

function dateSourceToJSDate(date: DateSource): Date {
    if (typeof date === 'object') {
        return date as Date;
    }

    return new Date(date);
}

// FIXME: Type of value is no longer Date, but rather delta in the specified unit. Need to convert.

export default function RelativeTime({ date }: Props) {
    const intl = useIntl();

    const dateFormat: FormatDateOptions = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
        timeZoneName: 'short',
    };

    const dateTime = DateTime.fromJSDate(dateSourceToJSDate(date));
    const durationFromNow = dateTime.diffNow();
    const [value, unit] = selectValueAndUnit(durationFromNow);

    return (
        <span title={intl.formatDate(date, dateFormat)}>
            <FormattedRelativeTime value={Math.round(value)} unit={unit} numeric="auto" />
        </span>
    );
}
